import {
  Component,
  forwardRef,
  Input,
  OnInit,
  OnChanges,
  EventEmitter,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormControl
} from '@angular/forms';

@Component({
  selector: 'ls-checkbox',
  templateUrl: './ls-checkbox.component.html',
  styleUrls: ['./ls-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LsCheckboxComponent),
      multi: true
    }
  ]
})
export class LsCheckboxComponent
  implements OnInit, OnChanges, ControlValueAccessor {
  public get value(): boolean {
    return this.innerValue;
  }

  public set value(value: boolean) {
    if (this.checkboxFormControl) {
      this.disabled = this.checkboxFormControl.disabled;
    }
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.propagateChange(value);
    }
  }

  private static id = 0;
  @Input()
  public description: string;
  @Input()
  public title: string;
  @Input()
  public disabled: boolean;

  @Input()
  public checkboxFormControl: FormControl;

  @Input()
  public wrapped = false;

  @Output()
  public checkboxValueChange: EventEmitter<boolean> = new EventEmitter();

  public identifier = `ls-checkbox-${LsCheckboxComponent.id++}`;
  private innerValue: boolean;

  public ngOnInit(): void {
    if (this.checkboxFormControl) {
      this.disabled = this.checkboxFormControl.disabled;
    }
  }

  public ngOnChanges(): void {
    if (this.checkboxFormControl) {
      this.disabled = this.checkboxFormControl.disabled;
    }
  }

  public writeValue(value: any): void {
    this.value = value;
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  public handleWrapperClick(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.checkboxValueChange.emit(this.innerValue);
  }

  private propagateChange = (_: any): void => {
    _ = _;
  };
}
